import { Box, styled } from '@mui/material';

export const PlaceAutocompleteItemContainer = styled(Box)(({ theme }) => ({
  padding: '8px',
  marginBottom: '2px',
  fontFamily: theme.typography.fontFamily,
  fontStyle: theme.typography.t14r.fontStyle,
  fontWeight: theme.typography.t14r.fontWeight,
  fontSize: theme.typography.t14r.fontSize,
  lineHeight: theme.typography.t14r.lineHeight,
  backgroundColor: theme.palette.case.neutral.n0,
  color: theme.palette.case.neutral.n700,

  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.case.neutral.n75,
    transition: '200ms',
    borderRadius: '4px',
  },
}));
